import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';

const EditRecipe = ({edit, setEdit, recipeId, name, ingredients, description}) => {

    const [newName, setNewName] = useState("");
    const [newIngredients, setNewIngredients] = useState("");
    const [newDescription, setNewDescription] = useState("");

    const editRecipe = async (e) => {
        
        if(newName === "") 
        return alert("name cannot be empty");

        const newData = {
            name: newName,
            ingredients: newIngredients,
            description: newDescription
        }

        const editedRecipe = await fetch(`https://recipe-app-backend-ionut.herokuapp.com/recipes/${recipeId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify(newData)
            })

        const response = editedRecipe.json();
        console.log(response);

        setNewName("");
        setNewIngredients("");
        setNewDescription("");
    }


    return (
        <div className="edit-section">
            <p>Name: </p>
            <input 
                value={newName} 
                type="text" 
                placeholder={name} 
                onChange={(e) => setNewName(e.target.value)
            }/>
            
            <p>Ingredients: </p>
            <input 
                value={newIngredients} 
                type="text" 
                placeholder={ingredients} 
                onChange={(e) => setNewIngredients(e.target.value)
            }/>
            
            <p>How to make it: </p>
            <textarea 
                value={newDescription} 
                type="text" 
                placeholder={description} 
                onChange={(e) => setNewDescription(e.target.value)
            }/>

            <Button
                className="close-editing"
                onClick={() => setEdit(!edit)}
                startIcon={<CancelPresentationIcon />}>
                Close
            </Button>

            <Button
                className="editing-button"
                onClick={editRecipe}
                startIcon={<PlaylistAddCheckIcon />}>
                Save
            </Button>
        </div>
    )
}

export default EditRecipe;
